// translations/pages/team/nl.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageNL = {
  hero: {
    title: 'Team',
    intro: 'Adrian Eisenmeier en Nikolai Genov hebben pAIoneer Labs GmbH opgericht en leiden het bedrijf als directeuren.',
    members: 'Adrian Eisenmeier is natuurkundige (Dipl.-Phys.) en ontwikkelt systemen daar waar AI, softwarearchitectuur, gegevensbescherming en beveiliging samenkomen. Nikolai Genov is gepromoveerd bio-informaticus en technisch lead voor AI-ondersteunde softwareontwikkeling en analytics in gereguleerde omgevingen in de gezondheidszorg, life sciences en de financiële sector. Alina Tselinina is softwareontwikkelaar en data engineer met een masterdiploma in financiële en actuariële wiskunde en ontwikkelt applicaties, REST-API’s en datapipelines in Python en R.'
  },
  card: {
    cta: 'Profiel bekijken'
  },
  profile: {
    overview: 'Team',
    membersLabel: 'Teamleden'
  }
};
